<!--
    Summary:
        hkml.exhibition.web - p7-procedures
    ChangeLog:
        wangn on 2020/11/16 added
-->
<template>
  <div class="v-p7-procedures" title="p7-procedures">
    <div class="header">
      <h2>{{$t('YDnaTest.p7_title')}}</h2>
    </div>
    <div class="content">
      <div class="box">
        <h5>{{$t('YDnaTest.p7_1')}}</h5>
        <div class="add-on">
          >
        </div>
      </div>
      <div class="box">
        <h5>{{$t('YDnaTest.p7_2')}}</h5>
        <div class="add-on">
          >
        </div>
      </div>
      <div class="box">
        <h5>{{$t('YDnaTest.p7_3')}}</h5>
        <div class="add-on">
          >
        </div>
      </div>
      <div class="box">
        <h5>{{$t('YDnaTest.p7_4')}}</h5>
        <div class="add-on">
          >
        </div>
      </div>
      <div class="box">
        <h5>{{$t('YDnaTest.p7_5')}}</h5>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "p7-procedures"
  }
</script>

<style scoped lang="scss">
  .en .v-p7-procedures{
    .content{
      .box{
        h5{
          font-size: .8vw;
        }
        .add-on {
          top: -.2vw;
          right: -3.5vw;
          font-size: 3vw;
          font-weight: bold;
          transform: scaleX(.5);
          color: #3bdbc0;
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  .v-p7-procedures {
    text-align: center;
    padding: 4vw 15vw 5vw;

    .header {
      margin-bottom: 2.5vw;

      h2 {
        color: #273a63;
        font-size: 2.66vw;
        font-weight: bold;
      }
    }

    .content {
      display: flex;
      justify-content: space-between;

      .box {
        position: relative;

        h5 {
          padding: 1vw;
          color: white;
          border-radius: 4vw;
          background-image: linear-gradient(to right, #459ebc, #34c1ae);
          font-size: 1.5vw;
        }

        .add-on {
          position: absolute;
          top: -2vw;
          right: -5.5vw;
          font-size: 6vw;
          font-weight: bold;
          transform: scaleX(.5);
          color: #3bdbc0;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/projects/y-dna-test/p7-procedures.vue